import { deepCopyClassName, IoCContainer, IUtils, WebCoreIoCKeys } from '..';
import { Sidebar, SidebarSide } from './sidebar.class';

export class SidebarManager {
    constructor(sidebarJSObj?: any) {
        let utils: IUtils = IoCContainer.get(WebCoreIoCKeys.IUtils);
        if (sidebarJSObj != null) {
            utils.deepCopy(this, sidebarJSObj);
        } else {
            this.sidebarList = [];
            this.isEnabled = true;
        }
    }

    public isEnabled: boolean;

    @deepCopyClassName(Sidebar)
    public sidebarList: Sidebar[];

    public add(side: SidebarSide = SidebarSide.Left, size: number = 200) {
        if (!this.sidebarList.some(sb => sb.orientation === side)) {
            let sidebar = new Sidebar();
            ((sidebar.orientation = side), (sidebar.size = size));

            this.sidebarList.push(sidebar);
        }
    }

    public remove(side: SidebarSide) {
        this.sidebarList = this.sidebarList.filter(sb => sb.orientation !== side);
    }

    public get(side: SidebarSide): Sidebar | undefined {
        return this.sidebarList.find(sb => sb.orientation === side);
    }

    public move(oldSide: SidebarSide, newSide: SidebarSide) {
        let bar = this.get(oldSide);
        if (bar) {
            bar.orientation = newSide;
        }
    }

    public resize(newSize: number, side: SidebarSide) {
        let bar = this.get(side);
        if (bar) {
            bar.size = newSize;
        }
    }
}
